import {useQuery} from 'react-query'
import {CertificateViewModalForm} from './CertificateViewModalForm'
import { isNotEmpty } from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { getCertificateById } from '../core/_requests'

const CertificateViewModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
        isLoading,
        data: certificate,
        error,
    } = useQuery(
        ['CERTIFICATE-VIEW', itemIdForUpdate],
        () => {
            return getCertificateById(itemIdForUpdate? itemIdForUpdate : 0).then(

            )
        },
        {
            cacheTime: 0,
            enabled: enabledQuery,
            onError: (err) => {
                setItemIdForUpdate(undefined)                
            },
        }
    )

    if (!itemIdForUpdate) {
        return null;
    }

    if (!isLoading && !error && certificate) {
        return <CertificateViewModalForm details={certificate} />
    }

    return null
}

export {CertificateViewModalFormWrapper}
